module.exports = __webpack_public_path__ + "static/media/patchExclamationFill.61cb955a.svg";